import { DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface ModalHeaderProps {
  title: string;
}

export const ModalHeader = ({ title }: ModalHeaderProps) => {
  return (
    <DialogHeader>
      <div className="flex justify-center mb-4">
        <img 
          src="/LogoPorteroYa.svg" 
          alt="Logo do PorteroYa - Conectando times a goleiros" 
          className="h-24 w-auto transform hover:scale-105 transition-transform duration-300 drop-shadow-xl"
        />
      </div>
      <DialogTitle className="text-center text-2xl font-bold text-primary dark:text-primary-foreground">
        {title}
      </DialogTitle>
    </DialogHeader>
  );
};